import { z } from 'zod'

export const convertAccountToCreditSchema = z.object({
  creditLimit: z.number().positive('Credit limit must be greater than 0'),
  closingDay: z.number().int().min(1).max(31),
})

export type ConvertAccountToCreditDto = z.infer<typeof convertAccountToCreditSchema>
